// [NT] color-swatch-image-sync.js
// 1) Clicking a color swatch updates the product image directly, independent
//    of whether size/boot size has been picked yet.
// 2) Refreshes availability across every option group on load and on every
//    change. Size-type fieldsets are checked in DOM order: the first one
//    (e.g. Boot Size) is evaluated normally from page load. Any size
//    fieldset that comes AFTER it (e.g. Body Size on Waders) is left alone -
//    not disabled, not styled - until every fieldset before it has a value
//    selected. Single-size products (just "Size") are unaffected, since
//    there's nothing before them.

function dbGetSelectedValues(scope, excludeFieldset) {
  var selected = [];
  var fieldsets = scope.querySelectorAll('fieldset.product-form__controls');
  fieldsets.forEach(function (fieldset) {
    if (fieldset === excludeFieldset) return;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) selected.push(checked.value);
  });
  return selected;
}

function dbFindLabelFor(radio) {
  if (radio.nextElementSibling && radio.nextElementSibling.tagName === 'LABEL') {
    return radio.nextElementSibling;
  }
  return radio.parentElement ? radio.parentElement.querySelector('label') : null;
}

function dbUpdateAllAvailability(scope, variants) {
  var fieldsets = scope.querySelectorAll('fieldset.product-form__controls');
  var nonColorFieldsets = [];
  fieldsets.forEach(function (f) {
    if (!f.querySelector('.color-swatch')) nonColorFieldsets.push(f);
  });

  fieldsets.forEach(function (targetFieldset) {
    var isColorFieldset = !!targetFieldset.querySelector('.color-swatch');
    var otherSelectedValues = dbGetSelectedValues(scope, targetFieldset);

    // [NT] pending until every size fieldset before this one has a pick
    var isPending = false;
    if (!isColorFieldset) {
      var myIndex = nonColorFieldsets.indexOf(targetFieldset);
      for (var i = 0; i < myIndex; i++) {
        if (!nonColorFieldsets[i].querySelector('input[type="radio"]:checked')) {
          isPending = true;
          break;
        }
      }
    }

    var radios = targetFieldset.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      var label = dbFindLabelFor(radio);

      if (isPending) {
        radio.classList.remove('disabled');
        radio.classList.remove('option-pending');
        if (label) label.classList.remove('option-pending');
        return;
      }

      radio.classList.remove('option-pending');
      if (label) label.classList.remove('option-pending');

      var candidateValue = radio.value;
      var hasAvailable = variants.some(function (v) {
        if (!v.available) return false;
        if (v.options.indexOf(candidateValue) === -1) return false;
        return otherSelectedValues.every(function (sel) {
          return v.options.indexOf(sel) !== -1;
        });
      });
      if (hasAvailable) {
        radio.classList.remove('disabled');
      } else {
        radio.classList.add('disabled');
      }
    });
  });
}

function dbGetVariants(scope) {
  var jsonScript = scope.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
  if (!jsonScript) return null;
  try {
    return JSON.parse(jsonScript.textContent);
  } catch (err) {
    return null;
  }
}

function dbInitAvailability() {
  document.querySelectorAll('[id^="MainProduct-"]').forEach(function (scope) {
    var variants = dbGetVariants(scope);
    if (variants) dbUpdateAllAvailability(scope, variants);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dbInitAvailability);
} else {
  dbInitAvailability();
}

document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.matches('input[type="radio"]')) return;

  var fieldset = input.closest('fieldset.product-form__controls');
  if (!fieldset) return;

  var scope = fieldset.closest('[id^="MainProduct-"]') || document;
  var variants = dbGetVariants(scope);
  if (!variants) return;

  dbUpdateAllAvailability(scope, variants);

  // Only a color swatch drives the product image
  if (!fieldset.querySelector('.color-swatch')) return;

  var chosenValue = input.value;
  var match = variants.find(function (v) { return v.available && v.options.indexOf(chosenValue) !== -1; })
    || variants.find(function (v) { return v.options.indexOf(chosenValue) !== -1; });

  if (!match || !match.featured_image || !match.featured_image.src) return;

  var filename = match.featured_image.src.split('/').pop().split('?')[0];

  // [NT] 2026-10-01: was scoped to '.product__media-list.js-media-list', which
  // only exists for slider gallery types - stacked_gallery's main list never
  // gets that class (see main-product.liquid), so this whole handler was a
  // silent no-op for the stacked grid. Widened to plain '.product__media-list'
  // so both layouts are covered.
  var mediaList = scope.querySelector('.product__media-list');
  if (!mediaList) return;

  var slides = mediaList.querySelectorAll('.product__media-item');
  var targetIndex = -1;
  var targetSlide = null;
  slides.forEach(function (slide, i) {
    var img = slide.querySelector('img');
    if (img && img.src && img.src.indexOf(filename) !== -1) {
      targetIndex = i;
      targetSlide = slide;
    }
  });

  if (targetIndex === -1) return;

  if (mediaList.swiper) {
    mediaList.swiper.slideTo(targetIndex);
  } else if (targetSlide) {
    // [NT] 2026-10-01: stacked_gallery (desktop) renders every image at once in
    // a static CSS grid, so there's no slide to move to and reordering the grid
    // on every swatch click just makes it jump around under the user. Instead,
    // leave the grid as-is, scroll the matching variant image into view, and
    // briefly highlight it so it's clear which tile just became relevant.
    slides.forEach(function (slide) { slide.classList.remove('color-swatch-highlight'); });
    targetSlide.classList.add('color-swatch-highlight');
    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    targetSlide.addEventListener('animationend', function () {
      targetSlide.classList.remove('color-swatch-highlight');
    }, { once: true });
  }
});